module.exports = __webpack_public_path__ + "static/media/bb.fe3ac3fe.svg";